import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import SharedOrganisaties from '../../components/authorization/organisaties/SharedOrganisaties';
import { Paper, Tab, Tabs } from '@mui/material';

const PagePlannenDelen: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const onTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  }

  return (
    <>
      <header className="app-header">
        <h1>Delen van plannen</h1>
        <p className="header-sub-title">
          Het is mogelijk om met organisaties standaard uw plannen te delen. Dit is mogelijk met organisaties die gekoppeld zijn aan een geografisch gebied, zoals een waterschap, netbeheerder of gemeente. Er zijn ook organisaties zonder geografisch gebied. Daarmee kunt u alleen individuele plannen delen.
        </p>
      </header>

      <div className="content text-left">
        <Tabs
          value={tabValue}
          onChange={onTabChange}
          aria-label="icon position tabs example"
        >
          <Tab iconPosition="start" label="Delen op basis van gebied" />
          <Tab label="Delen per plan" />
        </Tabs>
        {tabValue === 0 && (
          <Paper sx={{ width: '100%' }}>
            <div className="header">
              <h4>Overzicht van organisaties waarmee plannen worden gedeeld op basis van gebied</h4>
              <p>
                Met onderstaande organisaties worden uw plannen gedeeld op basis van overlap tussen het gebied van uw organisatie en de organisatie waarmee u plannen deelt. <a href="https://status.infraplannen.nl" target="_blank" rel="noopener noreferrer">Bekijk de gebieden</a>.
                Elke plan dat de zichtbaarheid instelling <b>Gedeeld</b> heeft wordt automatisch gedeeld. Heeft uw plan de zichtbaarheid instelling <b>Privé</b>, 
                dan wordt het plan niet gedeeld met onderstaande organisaties, tenzij u dat specifiek heeft aangegeven op het plan.
              </p>
              
              <SharedOrganisaties isZonderGebied={false} />
            </div>
            
          </Paper>
        )}
        {tabValue === 1 && (
          <Paper sx={{ width: '100%' }}>
            <div className="header">
              <h4>Overzicht van organisaties waarmee u specifieke plannen deelt</h4>
              <p>
                U kunt per plan instellen met welke organisatie u een specifiek plan wilt delen als u niet standaard uw plannen al deelt op basis van overlappend gebied. 
                Er zijn ook organisaties die geen gebied hebben in infraplannen.nl. 
                Met deze organisaties moet u per plan aangeven het plan te delen met die organisatie. 
                Plannen met zichtbaarheid instelling <b>Privé</b> moet u altijd specifiek delen met een organisatie. 
              </p>

              <SharedOrganisaties isZonderGebied={true} />
            </div>
          </Paper>
        )}

      </div>
      
      <Outlet /> 
    </>
  );
};

export default PagePlannenDelen;